const SupportedGeoAreas = [
    'south-yorkshire/barnsley',
    'burnley',
    'cardiff',
    'dundee',
    'harrogate',
    'huddersfield',
    'lincoln',
    'oldham',
    'nuneaton',
    'york'
] as const;

export type SupportedArea = (typeof SupportedGeoAreas)[number];

export const isSupportedArea = (area: string): area is SupportedArea => {
    return SupportedGeoAreas.some((a) => a === area);
};
